var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Module extends Component {
    constructor() {
        super('Module', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('scroll', () => {
                this.spy();
            });
            this.spy();
            this.success();
        });
    }
    spy() {
        const windowHeight = $(window).height();
        const topLimit = windowHeight / 4;
        const bottomLimit = windowHeight - topLimit;
        $('.module').each((module) => {
            var _a;
            const moduleTop = (_a = module.viewportPosition()) === null || _a === void 0 ? void 0 : _a.y;
            if (moduleTop === undefined)
                return;
            const moduleBottom = moduleTop + module.height();
            if ((moduleTop < bottomLimit && moduleBottom > topLimit) || (moduleTop <= topLimit && moduleBottom >= bottomLimit)) {
                module.addClass('is-in-viewport');
            }
            else {
                module.removeClass('is-in-viewport');
            }
        });
    }
}
